/*
export const someGetter = (state) => {}
 */

export default {
  getPermissions,
  stateNameOptions,
  stateOptions,
  autocompleteStateOptions,
  userTypeOptions,
  userStatusOptions,
  suffixOptions,
  documentTypeOptions,
  fileExtensions,
  entityOptions,
  shippingTypeOptions,
  activeIndicators
}

function getPermissions (state) {
  return state.permissionsList
}

function stateNameOptions (state) {
  return _.map(state.states, state => {
    return { label: state.STATE_NAME, value: state.LK_STATE_ID }
  })
}

function stateOptions (state) {
  return _.map(state.states, state => {
    return { label: state.STATE, value: state.LK_STATE_ID }
  })
}

function autocompleteStateOptions (state) {
  return _.map(state.states, state => {
    return { label: state.STATE, value: state.LK_STATE_ID }
  })
}

function userTypeOptions (state) {
  return _.map(state.userTypes, userType => {
    return { label: _.capitalize(userType.USER_TYPE), value: Number.parseInt(userType.LK_USER_TYPE_ID) }
  })
} 

function userStatusOptions (state) {
  return _.map(state.userStatuses, userStatus => {
    return { label: userStatus.STATUS, value: Number.parseInt(userStatus.LK_USER_STATUS_ID) }
  })
}

function suffixOptions (state) {
  return _.map(state.suffixes, suffix => {
    return { label: suffix.SUFFIX_NAME, value: suffix.LK_SUFFIX_NAME_ID }
  })
}

function documentTypeOptions (state, getters, rootState) {
  let types = _.filter(state.documentTypes, documentType => rootState.documents.uploadForm.LK_ENTITY_ID === documentType.LK_ENTITY_ID)

  types = types.map(documentType => {
      documentType.DOCUMENT_TYPE = _.join(_.split(documentType.DOCUMENT_TYPE, ' ').map(docType => _.capitalize(docType)), ' ')
      return { label: documentType.DOCUMENT_TYPE, value: documentType.LK_DOCUMENT_TYPE_ID }
    })
  // Alphabetize before returning
  types = _.sortBy(types, dt => dt.label)
  return types
}

function shippingTypeOptions (state) {
  return _.map(state.shippingTypes, shippingType => {
    return { label: shippingType.SHIPPING_TYPE, value: shippingType.LK_SHIPPING_TYPE_ID }
  })
}

function fileExtensions (state) {
  return _.join(_.map(state.fileTypes, fileType => fileType.FILE_EXTENSION), ', ')
}

function entityOptions (state) {
  return _.map(state.entities, entity => {
    return { label: _.capitalize(entity.ENTITY_NAME), value: Number.parseInt(entity.LK_ENTITY_ID) }
  })
}

function activeIndicators (state) {
  return state.activeIndicators
}